var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "holdRuleGroup"
  }, [_c('page-title', {
    attrs: {
      "title": _vm.pageTitle,
      "icon": "pe-7s-flag"
    }
  }), _vm.$route.name !== 'holdRuleGroupEdit' ? _c('b-row', {
    staticClass: "mb-4"
  }, [_c('b-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('b-card', [_c('b-card-title', [_vm._v("Groepsinformatie")]), _vm.groupDataLoading ? _c('font-awesome-icon', {
    staticClass: "mb-5",
    attrs: {
      "icon": "spinner",
      "spin": ""
    }
  }) : _c('b-table-simple', {
    attrs: {
      "small": ""
    }
  }, [_c('b-tbody', [_c('b-tr', [_c('b-th', [_vm._v("Naam")]), _c('b-td', [_vm._v(_vm._s(_vm.localState.groupData.display_name))])], 1), _c('b-tr', [_c('b-th', [_vm._v("Aangemaakt")]), _c('b-td', [_vm._v(_vm._s(_vm._f("datetime")(_vm.localState.groupData.created_at)))])], 1), _vm.localState.groupData.created_at !== _vm.localState.groupData.updated_at ? _c('b-tr', [_c('b-th', [_vm._v("Bijgewerkt")]), _c('b-td', [_vm._v(_vm._s(_vm._f("datetime")(_vm.localState.groupData.updated_at)))])], 1) : _vm._e(), _c('b-tr', [_c('b-th', [_vm._v("Status")]), _c('b-td', [_vm.localState.groupData.is_active ? _c('span', {
    staticClass: "badge badge-success"
  }, [_vm._v(" Actief ")]) : _c('span', {
    staticClass: "badge badge-danger"
  }, [_vm._v("Inactief")])])], 1), _c('b-tr', [_c('b-th', [_vm._v("Orderdata wijziging benodigd")]), _c('b-td', [!_vm.localState.groupData.is_approvable ? _c('span', [_vm._v("Ja")]) : _c('span', [_vm._v("Nee")])])], 1), _c('b-tr', [_c('b-th', [_vm._v("Is definitief")]), _c('b-td', [_vm.localState.groupData.is_status_hold_final ? _c('span', [_vm._v("Ja")]) : _c('span', [_vm._v("Nee")])])], 1), _vm.hasIgnoredProducts ? _c('b-tr', [_c('b-th', [_vm._v("Uitgesloten producten")]), _c('b-td', [_vm._v(_vm._s(_vm.ignoredProductIdenfiers))])], 1) : _vm._e()], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm.groupDataLoading ? _c('font-awesome-icon', {
    attrs: {
      "icon": "spinner",
      "spin": ""
    }
  }) : _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('router-view', {
    attrs: {
      "groupData": _vm.localState.groupData
    },
    on: {
      "refresh": _vm.refreshHandler
    }
  })], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-button', {
    staticClass: "bg-midnight-bloom text-white",
    on: {
      "click": _vm.backButtonHandler
    }
  }, [_vm._v(" Terug naar overzicht ")])], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }